import { useDocumentData } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";

import { doc } from "firebase/firestore";
import { getDate } from "@poseidon/firebase/timestamp";

export const useApplicationSummary = (applicationId) => {
  const [application, application_loading, application_error] = useDocumentData(
    doc(db, "applicationsSummary", applicationId),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  const [dealer, dealer_loading, dealer_error] = useDocumentData(
    application?.dealer
  );
  const [vessel, vessel_loading, vessel_error] = useDocumentData(
    application?.vessel
  );
  const loading = application_loading || dealer_loading || vessel_loading;
  const error = application_error || dealer_error || vessel_error;

  const combined =
    !loading && application && dealer && vessel
      ? {
          id: applicationId,
          ...mapApplicationSummary(application),
          dealer: dealer
            ? { id: application.dealer?.id, ...dealer }
            : undefined,
          vessel: vessel
            ? {
                id: application.vessel?.id,
                ...vessel,
                createdAt: getDate(vessel.createdAt),
                updatedAt: getDate(vessel.updatedAt),
              }
            : undefined,
        }
      : undefined;
  return {
    application: combined,
    loading,
    error,
  };
};

export const mapApplicationSummary = (application) => {
  const applicants = application?.applicants?.map((a, idx) => ({
    isJoint: idx > 0,
    sailor: a,
  }));
  const applicant = applicants?.at(0);
  const jointApplicant = applicants?.at(1);

  return {
    ...application,
    applicant,
    jointApplicant,
    applicants: [applicant, jointApplicant].filter((v) => !!v),
    completionDate: getDate(application.completionDate),
    createdAt: getDate(application.createdAt),
    updatedAt: getDate(application.updatedAt),
    isJoint: applicants.length > 1,
    lock_dealer: !!application.lock_dealer,
    creditSummaryStatusExpiry: getDate(application.creditSummaryStatusExpiry),
  };
};
